import { RECORDS_PER_PAGE } from "@root/constants";
import { useState } from "react";
import { InquiryService } from "@root/services/inquiry";
import {
  FETCH_INQUIRIES,
  ANSWER_INQUIRY,
  ADD_INQUIRY,
} from "@root/store/action-types/inquiry";
import { useNotification } from "./useNotification";
import { t } from "i18next";
import { TOAST_VARIANT } from "@root/constants";
function useInquiry() {
  const Inquiry_Service = new InquiryService();
  const { showNotification } = useNotification();
  const [fetchInquiryLoading, setFetchInquiryloading] = useState(false);
  const [addInquiryLoading, setAddInquiryLoading] = useState(false);
  const [answerInquiryLoading, setAnswerInquiryLoading] = useState(false);
  const [InquiryData, setInquiryData] = useState<any>(null);
  const [pageNo, setPageNo] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const pageSize = RECORDS_PER_PAGE;

  const payload = {
    offset: (pageNo - 1) * pageSize,
    limit: pageSize,
  };

  const onSuccess = (data: any, identifier: any) => {
    if (identifier === FETCH_INQUIRIES) {
      setFetchInquiryloading(false);
      setInquiryData(data?.rows);
      setPageCount(data?.count || 0);
    }
    if (identifier === ANSWER_INQUIRY) {
      setAnswerInquiryLoading(false);
      // Refresh the data after adding
      showNotification({
        type: TOAST_VARIANT.SUCCESS,
        message: t("inquiriesTab.answerSuccess"),
      });
      fetchInquiry(payload);
    }
    if (identifier === ADD_INQUIRY) {
      setAddInquiryLoading(false);
      // Show success notification for add
      showNotification({
        type: TOAST_VARIANT.SUCCESS,
        message: t("inquiriesTab.createSuccess"),
      });
    }
  };

  const onError = (error: any, identifier: any) => {
    // Fallback message
    const fallbackMessage = t("inquiriesTab.genericError");

    // Try to extract the actual backend error message
    const errorMessage =
      error?.response?.data?.message || error?.message || fallbackMessage;

    if (identifier === FETCH_INQUIRIES) {
      setFetchInquiryloading(false);
      showNotification({
        type: TOAST_VARIANT.ERROR,
        message: errorMessage,
      });
    }

    if (identifier === ANSWER_INQUIRY) {
      setAnswerInquiryLoading(false);
      showNotification({
        type: TOAST_VARIANT.ERROR,
        message: errorMessage,
      });
    }

    if (identifier === ADD_INQUIRY) {
      setAddInquiryLoading(false);
      showNotification({
        type: TOAST_VARIANT.ERROR,
        message: errorMessage,
      });
    }
  };

  const addInquiry = async (payload: any) => {
    setAddInquiryLoading(true);
    const identifier = ADD_INQUIRY;
    try {
      const response = await Inquiry_Service.AddInquiry(payload);

      // Use passed success callback
      onSuccess(response?.data, identifier);
    } catch (error) {
      // Use passed error callback
      onError(error, identifier);
    }
  };

  const fetchInquiry = async (payload: any) => {
    setFetchInquiryloading(true);
    const identifier = FETCH_INQUIRIES;
    try {
      const response = await Inquiry_Service.FetchInquiry(payload);
      // Use passed success callback
      onSuccess(response?.data.data, identifier);
    } catch (error: unknown) {
      onError(error, identifier);
    }
  };

  const answerInquiry = async (id: number, payload: any) => {
    setAnswerInquiryLoading(true);
    const identifier = ANSWER_INQUIRY;
    try {
      const response = await Inquiry_Service.AnswerInquiry(id, {
        answer: payload,
      });
      onSuccess(response?.data, identifier);
    } catch (error: unknown) {
      onError(error, identifier);
    }
  };

  return {
    addInquiryLoading,
    answerInquiryLoading,
    fetchInquiryLoading,
    InquiryData,
    pageNo,
    setPageNo,
    pageCount,
    pageSize,
    addInquiry,
    fetchInquiry,
    answerInquiry,
  };
}
export default useInquiry;
